module.exports = __webpack_public_path__ + "static/media/Storage-Facility.be4defe1.png";